
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  PafxFinancesNbCmdsFilters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\PafxFinancesNbCmdsFilters.ts

export class PafxFinancesNbCmdsFilters {

  // string MmDe
  public MmDe?: string=null;

  // string AaaaDe
  public AaaaDe?: string=null;

  // string MmA
  public MmA?: string=null;

  // string AaaaA
  public AaaaA?: string=null;

  // string PolCod
  public PolCod?: string=null;

  // string RegCod
  public RegCod?: string=null;

  // string SocCod
  public SocCod?: string=null;

  // string[] EtbCods
  public EtbCods: string[]=[];

  // decimal? MntMin
  public MntMin?: number=null;

  // decimal? MntMax
  public MntMax?: number=null;

  // bool? TopPerimetre
  public TopPerimetre?: boolean=null;

  // bool? TopDetailParEtb
  public TopDetailParEtb?: boolean=null;
}